export enum RequestState {
  Loading = "fetching",
  Error = "error",
  Success = "success",
  SuccessEmpty = "successEmpty",
  Paused = "paused"
}
